import React from 'react';
import { Box } from '@mui/material';
import type { MoveQualityCounts } from 'endchess-contracts';
import {
  MOVE_QUALITY_BUBBLE_STYLES,
  MOVE_QUALITY_LABELS,
  MOVE_QUALITY_ORDER,
  type MoveQualityKey,
} from './moveQualityStyles';

type MoveQualityCountBubblesProps = {
  counts: MoveQualityCounts;
};

const MoveQualityCountBubble = ({
  quality,
  count,
}: {
  quality: MoveQualityKey;
  count: number;
}) => {
  if (count <= 0) {
    return null;
  }

  const style = MOVE_QUALITY_BUBBLE_STYLES[quality];

  return (
    <Box
      component="span"
      title={`${MOVE_QUALITY_LABELS[quality]}: ${count}`}
      aria-label={`${count} ${MOVE_QUALITY_LABELS[quality].toLowerCase()} move${count === 1 ? '' : 's'}`}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 20,
        height: 20,
        px: 0.75,
        borderRadius: '10px',
        bgcolor: style.bgcolor,
        color: style.color,
        fontSize: '0.7rem',
        fontWeight: 700,
        lineHeight: 1,
      }}
    >
      {count}
    </Box>
  );
};

const MoveQualityCountBubbles = ({ counts }: MoveQualityCountBubblesProps) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.5,
      flexWrap: 'wrap',
      verticalAlign: 'middle',
    }}
  >
    {MOVE_QUALITY_ORDER.map((quality) => (
      <MoveQualityCountBubble
        key={quality}
        quality={quality}
        count={counts[quality]}
      />
    ))}
  </Box>
);

export default MoveQualityCountBubbles;
